import * as yup from "yup";

export const BuyingEmailFormSchema_passwordRequired = 
  yup.object().shape({
    buyingEmail: yup.object().shape({
      emailAddress: yup.string().email("Email Address should be a valid email").required("Email Address is required"),
      assignedUserID: yup.number().required("Assigned User is required").integer("Assigned User is required"),
      mailboxPassword: yup.string().required("Email Password is required"),
      isActive: yup.boolean(),
      isDeleted: yup.boolean(),
    }),
    platformCredentials: yup.array().of(yup.object().shape(
      {
        platformId: yup.number("Platform is required").integer("Platform is required").required("Platform is required"),
        platformPassword: yup.string().required("Platform Password is required"),
        shortName: yup.string().nullable(),
        idx: yup.number().integer(),
      }
    ))
  })

export const BuyingEmailFormSchema_noPasswordRequired = yup.object().shape({
  buyingEmail: yup.object().shape({
    emailAddress: yup.string().email("Email Address should be a valid email").required("Email Address is required"),
    assignedUserID: yup.number().required("Assigned User is required").integer("Assigned User is required"),
    mailboxPassword: yup.string(),//.required("Email Password is required"),
    isActive: yup.boolean(),
    isDeleted: yup.boolean(),
  }),
  platformCredentials: yup.array().of(yup.object().shape(
    {
      platformId: yup.number("Platform is a required field").integer("Platform is a required field").required("Platform is a required field"),
      platformPassword: yup.string().required("Platform Password is a required field"),
      shortName: yup.string().nullable(),
      idx: yup.number().integer(),
    }
  ))
})